import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { track } from './openpanel';

/** Query params que no deben enviarse a analytics (tokens, enlaces sensibles). */
const STRIPPED_PAGEview_SEARCH_KEYS = new Set(['reference']);

function sanitizeSearchForPageview(search: string): string {
  if (!search) return '';
  const raw = search.startsWith('?') ? search.slice(1) : search;
  if (!raw) return '';
  const params = new URLSearchParams(raw);
  for (const key of STRIPPED_PAGEview_SEARCH_KEYS) {
    params.delete(key);
  }
  const next = params.toString();
  return next ? `?${next}` : '';
}

export function OpenPanelRouteTracking() {
  const location = useLocation();

  useEffect(() => {
    track('pageview', {
      path: location.pathname,
      search: sanitizeSearchForPageview(location.search),
      hash: location.hash,
    });
  }, [location.pathname, location.search, location.hash]);

  return null;
}

